import { FaroButtonSpinner } from "@components/common/button/faro-button-spinner";
import { FaroDatePicker } from "@components/common/faro-text-button-date-picker/faro-date-picker";
import { Button, CalendarIcon, CloseIcon } from "@flat-ui";
import { useDateTime } from "@hooks/use-date-time";
import { getSvgColoredIconCss } from "@utils/ui-utils";
import { useMemo } from "react";
import { PALETTE_VARS } from "@styles/palette-vars";
/** Used to control the visibility on hover */
const CLEAR_ICON_CLASS_NAME = "clear_icon";

/** Shows a text button with date label and allows user to select a date by clicking on the button */
export function FaroTextButtonDatePicker({
  isDisabled,
  isLoading,
  isClearable = false,
  anchorEl,
  onDateConfirmed,
  closeDatePicker,
  updateAnchorEl,
  buttonSx,
  value
}) {
  const {
    formatDate
  } = useDateTime();
  const formattedDate = useMemo(() => {
    if (value === null) {
      return undefined;
    }
    return formatDate(value);
  }, [formatDate, value]);
  let endIcon;
  if (isLoading) {
    endIcon = <FaroButtonSpinner />;
  } else if (value && isClearable) {
    endIcon = <CloseIcon className={CLEAR_ICON_CLASS_NAME} onClick={event => {
      event.stopPropagation();
      onDateConfirmed(null);
    }} sx={{
      ...getSvgColoredIconCss(PALETTE_VARS.text.disabled),
      visibility: "hidden",
      padding: "4px",
      height: "24px",
      width: "24px",
      "&:hover": {
        ...getSvgColoredIconCss(PALETTE_VARS.primary.main),
        backgroundColor: "action.hover",
        borderRadius: "50%"
      }
    }} />;
  }
  return <>
      <Button disableRipple draggable={false} endIcon={endIcon} variant="ghost" disabled={isDisabled} onClick={event_0 => {
      event_0.stopPropagation();
      updateAnchorEl(event_0);
    }} sx={{
      display: "flex",
      fontSize: "12px",
      justifyContent: "space-between",
      alignItems: "center",
      width: "100%",
      height: "100%",
      // The variant applies a 5.5rem min-width, which is too wide for the
      // narrow columns this button is rendered in.
      minWidth: 0,
      px: "8px",
      cursor: "pointer",
      gap: "10px",
      borderBottom: `1px solid ${anchorEl ? "primary.light" : "transparent"}`,
      borderRadius: 0,
      background: anchorEl ? "white" : "",
      textTransform: "none",
      "&:hover": {
        background: anchorEl ? "white" : "transparent",
        [`& .${CLEAR_ICON_CLASS_NAME}`]: {
          visibility: "visible"
        },
        borderBottom: !anchorEl && !isDisabled ? `1px solid ${PALETTE_VARS.text.primary}` : ""
      },
      ...buttonSx
    }}>
        {formattedDate ? <var>{formattedDate}</var> : <CalendarIcon sx={{
        height: "18px",
        color: "text.secondary"
      }} />}
      </Button>

      {anchorEl && <FaroDatePicker anchorEl={anchorEl} closeDatePicker={closeDatePicker} initialDate={value} onDateConfirmed={updatedDate => onDateConfirmed(updatedDate ? updatedDate.toJSDate() : null)} />}
    </>;
}